import { render, staticRenderFns } from "./FadingRouter.vue?vue&type=template&id=0a1fbf3a&scoped=true&"
import script from "./FadingRouter.vue?vue&type=script&lang=js&"
export * from "./FadingRouter.vue?vue&type=script&lang=js&"
import style0 from "./FadingRouter.vue?vue&type=style&index=0&id=0a1fbf3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1fbf3a",
  null
  
)

export default component.exports